import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormSubmitEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-form-submit-embed',
	path: '/jira/core/projects/:projectKey/form/:formId/embed',
	exact: true,
};
